import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectSettings } from "../app/slices/settingsSlice";

export const useSettings = () => {
	const settings = useSelector(selectSettings);

	return useMemo(() => ({ settings }), [settings]);
};
